<template>
  <table-layout>
    <template v-slot:title>
      증명서 신청내역
    </template>
    <template v-slot:button>
      <v-flex xl6 lg6 md6 sm8 xs8>
        <v-select
          v-model="state"
          :items="stateList"
          item-text="text"
          item-value="value"
          placeholder="전체"
          outlined hide-details dense
          background-color="white"
          @change="changeState"
        />
      </v-flex>
    </template>
    <template v-slot:table>
      <v-data-table
        height="65vh"
        fixed-header
        :headers="getHeader(isAdmin ? certAdminTable : certUserTable)"
        :items="data"
        :items-per-page="-1"
        no-data-text="조회된 데이터가 없습니다"
        mobile-breakpoint="md"
      >
        <template v-slot:item.ssno="{ value }">
          <div>{{ setSsnoMasking(value) }}</div>
        </template>
        <template v-slot:item.createDate="{ value }">
          <div>{{ setTableDateFormat(value) }}</div>
        </template>
        <template v-slot:item.updateDate="{ value }">
          <div>{{ setTableDateFormat(value) }}</div>
        </template>
        <template v-slot:item.certificateType="{ value }">
          <div>{{ dataConversion(certificateTypeList, value) }}</div>
        </template>
        <template v-slot:item.cardDetail="{ item }">
          <v-btn v-if="item.certificateType === '명함신청'" class="button" outlined @click="showCardDetail(item)">
            상세보기
          </v-btn>
        </template>
        <template v-slot:item.state="{ value }">
          <div>{{ dataConversion(certificateStateList, value) }}</div>
        </template>
        <template v-slot:item.etc="{ item }">
          <div class="buttons-layout">
            <v-btn class="button" outlined @click="showCertFile('preview', item)" :disabled="item.state !== 'COMP'">
              미리보기
            </v-btn>
            <v-btn class="button" outlined @click="showCertFile('download', item)" :disabled="item.state !== 'COMP'">
              다운로드
            </v-btn>
          </div>
        </template>
        <template v-slot:item.issue="{ item }">
          <v-btn class="button" outlined @click="showCertIssue(item)" :disabled="item.state === 'COMP' || item.state === 'REJECT'">
            발급
          </v-btn>
        </template>
      </v-data-table>
    </template>
    <template v-slot:popup>
      <certificate-issue
        :is-show="isShowCertIssue"
        :select-data="selectData"
        @refresh="$emit('refresh')"
        @close="isShowCertIssue = false"
      />
      <business-card-signup
        :is-show="isShowCardDetail"
        :select-data="selectData"
        popup-type="detail"
        @close="isShowCardDetail = false"
      />
    </template>
  </table-layout>
</template>
<script>
import TableLayout from "@/common/layout/TableLayout.vue";
import {
  CERTIFICATE_SIGNUP_ADMIN_TABLE,
  CERTIFICATE_SIGNUP_USER_TABLE
} from "@/util/TableHeaders";
import TableMixin from "@/mixin/TableMixin";
import {mapGetters} from "vuex";
import DateMixin from "@/mixin/DateMixin";
import constant from "@/util/constant";
import CertificateIssue from "@/pages/Certificate/popup/CertificateIssue.vue";
import {axiosInstance} from "@/util/AxiosModule";
import BusinessCardSignup from "@/pages/Certificate/popup/BusinessCardSignup.vue";

export default {
  name: "CertificateSignupTable",
  components: {BusinessCardSignup, CertificateIssue, TableLayout},
  props: ["data", "loading"],
  mixins: [TableMixin, DateMixin],
  data() {
    return {
      certAdminTable: CERTIFICATE_SIGNUP_ADMIN_TABLE,
      certUserTable: CERTIFICATE_SIGNUP_USER_TABLE,
      state: "",
      stateList: [
        { text: "전체", value: "" },
        { text: "진행중", value: "ING" },
        { text: "처리", value: "END" }
      ],
      certificateTypeList: constant.CERTIFICATE_TYPE_LIST,
      certificateStateList: constant.CERTIFICATE_STATE_LIST,
      isShowCertIssue: false,
      selectData: {},
      isShowCardDetail: false
    }
  },
  computed: {
    ...mapGetters("login", {
      memberRole: "memberRole",
      memberId: "memberId"
    }),
    isAdmin() {
      return this.memberRole === "ADMIN";
    }
  },
  methods: {
    showCertIssue(data) {
      this.isShowCertIssue = true;
      this.selectData = data;
    },
    showCertFile(type, item) {
      const params = {
        certificateId: item.certificateId,
        memberId: this.memberId
      };
      this.getCertFileData(type, item, params);
    },
    async getCertFileData(type, item, params) {
      try {
        const { data } = await axiosInstance.get("/private/certificate/fileView", {
          responseType: 'blob',
          params
        });

        if (type === "preview") {
          this.showImageFromBlob(item, data);
        }
        if (type === "download") {
          this.downloadFile(item, data);
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    downloadFile(item, blob) {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      const fileType = item.certificateType === "명함신청" ? "png" : "pdf";

      link.href = url;
      link.download = `${this.dataConversion(this.certificateTypeList, item.certificateType)}_${item.reqNm}${'.' + fileType}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    showImageFromBlob(item, blob) {
      const fileType = item.certificateType === "명함신청" ? "image/png" : "application/pdf";
      const blobData = new Blob([blob], {type: fileType});
      const imageUrl = URL.createObjectURL(blobData);
      window.open(imageUrl, "_blank");
    },
    changeState(state) {
      this.$emit("change", state);
    },
    showCardDetail(item) {
      this.selectData = item;
      this.isShowCardDetail = true;
    }
  }
}
</script>